import React from "react";
import styles from "./loader.scss";

const { icon_loader, shimmer_box, box_inside, heading, visual } = styles;

const IconLoader = () => {
  return (
    <div className={icon_loader}>
      <div className={shimmer_box}>
        <div className={box_inside}>
          <div className={heading}>
            <span className={visual}></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IconLoader;
